import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SelectionType } from '@swimlane/ngx-datatable';
import { Modal } from 'bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Page } from 'src/app/classes/page';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { BylawsService } from 'src/app/services/bylaws.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-amendments-history',
  templateUrl: './amendments-history.component.html',
  styleUrls: ['./amendments-history.component.scss']
})
export class AmendmentsHistoryComponent {
  options = { checkboxes: true }
  applicationModel = 1;
  aplicationDetailList: any
  societyDropdownData: any
  blockDropdownData: any;
  AmendmentsList: any;
  selectedRemarkDetails: any;
  temp: any;
  bylawsProgress: any;
  ExpendeText = '';
  OrderCertiftcateData: any = {
    bylaws: [],
    societyName: '',
    societyAddress: '',
    societyRegistrationNo: '',
    approvedate: ''
  };
  orderData = [
    {

      "byLaws": "Johnson, Johnson and Partners, LLC CMP DDC",
      "bylawsNo": 22
    },
    {
      "name": "Claudine Neal",
      "gender": "female",
      "byLaws": "Sealoud",
      "bylawsNo": 55
    },

    ,];
  selected: any[] = [];
  societyDetails: any
  ColumnMode = 'ColumnMode';
  SelectionType = SelectionType;
  orderColumns: any = [
    { prop: 'id', name: "id", width: 50, sorting: true },
    { prop: 'sByLawsNo', name: 'Bye-Laws Number', width: 100 },
    { prop: 'sNewByLawsDetail', name: 'bye-Laws', align: { head: 'center' } },

  ];
  roles: any
  currentUser: any
  selectionType: 'checkbox' | 'multi' | 'single' = 'checkbox';
  disclamerOptions: any[] = [];
  disclamerOptionsBackup: any[] = [];
  columns1: any;
  rolesBlock: number[] = [11, 12, 13, 19];
  rolesSubDivision: number[] = [36, 37, 38];
  setColumns() {
    this.columns1 = [
      { name: '#', prop: 'id', sortable: false, maxWidth: 40 },
      { name: 'Date', prop: 'dCreateDate', sortable: true },
      { name: 'Society Name', prop: 'sSocietyName', sortable: true },
      { name: 'Society Type', prop: 'sName', sortable: true },

      this.rolesSubDivision.includes(this.currentUser.roleId)
        ? {
          name: 'Sub-Division',
          prop: 'sSubDivisionName',
          sortable: true,
        }
        : this.rolesBlock.includes(this.currentUser.roleId)
          ? {
            name: 'Society Block',
            prop: 'SBlockName',
            sortable: true,
          }
          : null,

      { name: 'Status', prop: 'sAuditStatus', sortable: true },
      { name: 'Action', prop: 'action', sortable: false }
    ].filter(Boolean);
  }

  columns = [
    {
      name: '#',
      prop: 'index',
      cellTemplate: 'indexTemplate', // Optional: Can use a custom template if needed
      sortable: false
    },
    {
      name: 'Amendment Type',
      prop: 'sAmmendmentType',
      cellTemplate: 'amendmentTypeTemplate', // Optional: Can use a custom template if needed
      sortable: true,
      maxWidth: 150
    },
    {
      name: 'Bye-laws Number',
      prop: 'sByLawsNo',
      sortable: true,
      maxWidth: 200
    },
    {
      name: 'Bye-laws',
      prop: 'sNewByLawsDetail',
      sortable: true,
      maxWidth: 300
    },
    {
      name: 'Liability',
      prop: 'isLiablity',
      cellTemplate: 'liabilityTemplate', // Optional: Can use a custom template if needed
      sortable: true,
      maxWidth: 150
    },
    {
      name: 'Action',
      prop: 'action',
      cellTemplate: 'actionTemplate', // Optional: Can use a custom template if needed
      sortable: false
    }
  ];
  byLawsForm!: FormGroup
  byLawsDateForm!: FormGroup
  updateStatusForm!: FormGroup
  showDisclamer = false
  remarkList: any;
  checkboxOptions: any[] = [
    { id: 1, label: "It is not contrary to the provisions of this Act and the Rules." },
    { id: 2, label: "It does not conflict with Co-operative principles." },
    { id: 3, label: "It will promote the economic or social interest of the members of the society." },
    { id: 4, label: "It is not inconsistent with the principles of social justice." }

  ];
  constructor(private fb: FormBuilder, private configService: ConfigService, private toastService: ToastService, private sanitizer: DomSanitizer, private byLawsService: BylawsService, private router: Router, private ngxUiLoaderService: NgxUiLoaderService, private authService: AuthService) {

  }
  onSelect(selected: any) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected?.selected);
  }



  add() {
    this.selected.push(this.orderData[1], this.orderData[3]);
  }

  update() {
    this.selected = [this.orderData[1], this.orderData[3]];
  }

  remove() {
    this.selected = [];
  }


  ngOnInit(): void {
    // let user: any = localStorage.getItem('currentUser')
    this.currentUser = this.authService.currentUserValue
    this.setColumns();

    this.byLawsForm = this.fb.group({
      societyType: [0, Validators.required],
      // societyBlock: [0, Validators.required],

    })
    this.byLawsDateForm = this.fb.group({
      date: [null, Validators.required],
      // societyBlock: [0, Validators.required],

    })
    this.updateStatusForm = this.fb.group({
      role: [''],
      statusFile: [''],
      status: ['', Validators.required],
      remark: ['', Validators.required],
      checkboxes: this.fb.array([], [this.allCheckboxesRequired()])

    })
    this.updateStatusForm.controls['remark'].disable()
    this.updateStatusForm.controls['statusFile'].disable()
    this.updateStatusForm.controls['status'].disable()
    // this.getDropDo/wnData()
    let society: any = sessionStorage.getItem('societyDetail');
    this.societyDetails = JSON.parse(society);

    if (this.societyDetails && this.currentUser.roleId == 9) {
      this.getAmendmentsList(this.societyDetails?.iSocietyDetailsId);
    } else {
      this.getDropDownData();
      this.getSocietyList();

    }
    this.getDisclaimer();
  }


  // Getter for the FormArray
  get checkboxes() {
    return this.updateStatusForm.get('checkboxes') as FormArray;
  }

  // Custom validator to check if all checkboxes are selected
  allCheckboxesRequired(): any {
    return (formArray: FormArray): { [key: string]: boolean } | null => {
      const selectedCheckboxes = formArray.controls.filter(control => control.value); // Get all selected (checked) checkboxes
      if (selectedCheckboxes.length === this.checkboxOptions.length) {
        return null;  // Valid if all checkboxes are checked
      } else {
        return { allRequired: true };  // Invalid if not all checkboxes are checked
      }
    };
  }

  // Function to add checkboxes to the form array
  addCheckbox(option: any): void {
    option.forEach((element: any) => {
      const control = this.fb.control(false); // initially unchecked
      this.checkboxes.push(control);

    });

  }
  openPicker(picker: HTMLInputElement) {
    picker.showPicker?.();
    picker.focus();
  }
  getFileExtension(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf('.'); // Find the last dot
    return lastDotIndex !== -1
      ? fileName.substring(lastDotIndex + 1).toLowerCase()
      : ''; // Get substring after the last dot
  }
  async onFileSelected(event: any, fileInput: string) {
    const file = event.target.files[0];

    if (file) {
      let fileName = file.name;
      let fileExtension = this.getFileExtension(file.name);

      if (
        fileExtension !== 'jpg' &&
        fileExtension !== 'jpeg' &&
        fileExtension !== 'png' &&
        fileExtension !== 'pdf'
      ) {
        this.toastService.showError(
          'Invalid file type. Allowed types: jpg, jpeg, png, pdf.'
        );
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
      if (fileSizeInMB > 2) {
        this.toastService.showError(
          'File size should be less then or equal 2 MB'
        ); // Display error if file size exceeds 2MB
        return;
      }


      let blob = new Blob([file], { type: file.type })
      let content = await this.blobToBase64(blob);
      let obj = {
        path: fileName,
        content: content
      }
      this.updateStatusForm.get(fileInput)?.setValue(obj);
    } else {
      this.updateStatusForm.get(fileInput)?.setValue('');
    }

  }
  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // When the reader finishes, resolve the promise with the result (Base64 string)
      reader.onloadend = () => {
        resolve(reader.result as string);  // Base64 string is available here
      };

      // Handle any errors
      reader.onerror = (error) => {
        reject(error);
      };

      // Read the Blob as a Data URL (Base64)
      reader.readAsDataURL(blob);
    });
  }
  toggle(check: number) {
    this.applicationModel = check
  }
  submit() {
    this.getAmendmentsList(this.societyDetails?.iSocietyDetailsId);
  }
  submitSociety() {
    this.getSocietyList();
  }
  getSocietyList() {

    let obj = {
      // IBlockId: this.byLawsForm.value.societyBlock ? this.byLawsForm.value.societyBlock : 0,
      iSTypeid: this.byLawsForm.value.societyType ? this.byLawsForm.value.societyType : 0,
      action: '',
      iAreaOperation: 0,
      iSubdivision: 0
    }
    if ([11, 13, 19].includes(this.currentUser.roleId)) {
      obj.action = 'GetSocietyDetailbyRoleID',
        obj.iAreaOperation = this.currentUser.iAreaOperation
      obj.iSubdivision = this.currentUser.iSubdivision


    }

    if ([36, 37, 38].includes(this.currentUser.roleId)) {
      obj.action = 'GetSocietyDetailbyRoleID2006',
        obj.iAreaOperation = this.currentUser.iAreaOperation
      obj.iSubdivision = this.currentUser.iSubdivision
    }

    this.byLawsService.getSocietyList(obj).subscribe((res: any) => {

      if (res?.status == 200 && res?.data && res?.data.length) {
        this.AmendmentsList = res?.data;
        this.temp = res?.data;
        //  this.toastService.showSuccess(res?.message)
      } else {
        this.AmendmentsList = [];
        this.temp = [];
        this.toastService.showInfo(res?.message)
      }

    }, (res) => {

      if (res.status != 200) {


      }
    })

  }
  getAmendmentsList(societyID: any) {
    let obj = {
      iSocietyDetailsId: societyID
    }
    let date = this.byLawsDateForm.value.date ? this.byLawsDateForm.value.date : ''
    this.ngxUiLoaderService.start();

    if (this.societyDetails.iSocietyId == 1) {
      this.byLawsService.getAmmendmentList2006(obj, date).subscribe((res: any) => {
        this.ngxUiLoaderService.stop();
        if (res?.status == 200 && res?.data && res?.data.length) {

          this.AmendmentsList = res?.data;

          this.temp = res?.data
        } else {
          this.AmendmentsList = [];
          this.temp = []
          this.toastService.showInfo(res?.message)
        }

      }, (res) => {
        this.ngxUiLoaderService.stop();
        if (res.status != 200) {

          this.toastService.showError(res?.message)
        }
      })
    } else {
      this.byLawsService.getAmmendmentList(obj, date).subscribe((res: any) => {
        this.ngxUiLoaderService.stop();
        if (res?.status == 200 && res?.data && res?.data.length) {
          this.AmendmentsList = res?.data;
          this.temp = res?.data
        } else {
          this.AmendmentsList = [];
          this.temp = []

          this.toastService.showInfo(res?.message)
        }

      }, (res) => {
        this.ngxUiLoaderService.stop();
        if (res.status != 200) {

          this.toastService.showError(res?.message)
        }
      })
    }
  }
  
  getApplicationDetail(data: any) {

    let obj = {
      iByLawsId: data?.iByLawsId,
      iByLawsDetailId: data?.iByLawsId
    }
    this.ngxUiLoaderService.start();
    if ([36, 37, 38].includes(this.currentUser.roleId)
      || this.societyDetails?.iSocietyId == 1) {
      this.byLawsService.getApplicationDetails2006(obj).subscribe((res: any) => {
        if (res?.status == 200 && res?.data) {
          this.aplicationDetailList = res?.data

          this.aplicationDetailList.selectedRow = data
          // this.openModal('AmendmentsAppDetails2006')
        }
        this.ngxUiLoaderService.stop()

      }, (res) => {
        if (res.status != 200) {
          this.ngxUiLoaderService.stop()

        }
      })



      this.getBindRoles('BindRoles2006');
      //  if (data?.sAuditStatus != 'Pending') {

      this.getbylawsProgressDetail(data, 'ByLawsProgress2006');
      // }

      this.getUserRemarks(data?.iByLawsId, 'GetRemark2006')
    } else {
      this.byLawsService.getApplicationDeatails(obj).subscribe((res: any) => {
        if (res?.status == 200 && res?.data) {
          this.aplicationDetailList = res?.data

          this.aplicationDetailList.selectedRow = data
          // this.openModal('AmendmentsAppDetails')
        }
        this.ngxUiLoaderService.stop();
      }, (res) => {
        if (res.status != 200) {
          this.ngxUiLoaderService.stop();

        }
      })



      this.getBindRoles('BindRoles');

      this.getbylawsProgressDetail(data, 'ByLawsProgress');


      this.getUserRemarks(data?.iByLawsId, 'GetRemark')
        this.getBindByLawsOrderDetail(data);
    }
    //     if (this.currentUser.roleId == 9) {
    //          if(this.societyDetails.iSocietyId == 1){
    //        this.getbylawsProgressDetail(data,'ByLawsProgress2006');
    //          }else{
    //   this.getbylawsProgressDetail(data,'ByLawsProgress');
    //          }

    //       this.getBindByLawsOrderDetail(data);
    //     } else {
    //        if ([36,37,38] .includes( this.currentUser.roleId)) {
    //  this.getbylawsProgressDetail(data,'ByLawsProgress2006');
    //      this.getBindRoles('BindRoles2006');
    //         }else{
    //  this.getbylawsProgressDetail(data,'ByLawsProgress');
    //      this.getBindRoles('BindRoles');
    //        this.getBindByLawsOrderDetail(data);
    //         }

    //     }



  }

  getByLawsOrderCertificate(data: any) {
let action=''
   if(this.societyDetails.iSocietyId ==1){
action='ByLawsOrderCertificate2006'
   } else{
    action='ByLawsOrderCertificate'
   }
    this.byLawsService.getByLawsOrderCertificate(this.societyDetails?.iSocietyDetailsId, data?.iByLawsId, action).subscribe((res: any) => {
      if (res?.status == 200 && res?.data && res?.data.length > 0) {

        this.OrderCertiftcateData.bylaws = JSON.parse(res?.data[0]?.ByLawsDetails);
        this.OrderCertiftcateData.societyRegistrationNo = res?.data[0]?.sSocietyRegistrationNo;
        this.OrderCertiftcateData.societyName = res?.data[0]?.sSocietyName;
        this.OrderCertiftcateData.approvedate = res?.data[0]?.ApprovedDate;
        let address = res?.data[0]?.sAddress1 + ", " + res?.data[0]?.sVillageName + ", " + res?.data[0]?.SBlockName + ", Tehsil & Distt. " + res?.data[0]?.SDistrictName + ", H.P ," + res?.data[0]?.sPincode
        this.OrderCertiftcateData.societyAddress = address;
      } else {
        this.OrderCertiftcateData = {
          bylaws: [],
          societyName: '',
          societyAddress: '',
          societyRegistrationNo: ''
        }
      }


    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }

  closeOrder() {
    this.OrderCertiftcateData = {
      bylaws: [],
      societyName: '',
      societyAddress: '',
      societyRegistrationNo: ''
    }
  }
  getbylawsProgressDetail(data: any, action: any) {
    if (this.currentUser.roleId == 9) {
      data.iSocietyDetailsId = this.societyDetails?.iSocietyDetailsId
    }
    this.byLawsService.getByLawsProgressDetail(data, action).subscribe((res: any) => {
      if (res?.status == 200 && res?.data && res?.data.length > 0) {
        this.bylawsProgress = res?.data;
      } else {
        this.bylawsProgress = [];
      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }
  closeModel() {
    this.aplicationDetailList = []
    this.aplicationDetailList.selectedRow = null
    this.applicationModel = 1
    this.updateStatusForm.reset();
    this.selectedRemarkDetails = null;
    this.remarkList = []

  }
  downloadDocument(path: any) {
    if (path) {
      const fileUrl = this.byLawsService.downloadPath(path);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank'; // Open in a new tab
      link.download = fileUrl.split('/').pop() || 'downloaded-file'; // Extract filename from URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      this.toastService.showError('Document path is not available');
    }
  }
  downloadFile(fileName: string) {

        let fileUrl:any = '';
    if(fileName.includes('/')){
       fileUrl = this.configService.getFileUrl() + fileName;
    }else{
       fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
    }
    // const fileUrl = this.configService.getFileUrl() + 'ByLaws/' + fileName;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.target = '_blank'; // Optional: specify a file name
    link.click();
  }

  getDropDownData() {
    this.byLawsService.getDropDownData1().subscribe(response => {
      if (response?.status === 200 && response?.data) {
        if ([11, 13, 19].includes(this.currentUser.roleId) || this.societyDetails?.iSocietyId == 2) {
          this.societyDropdownData = response.data.societyType;
        } else {
          this.societyDropdownData = response.data.societyType2006;
        }

        this.blockDropdownData = response.data.blocks;
      }

    })
  }
  getBindRoles(action: any) {
    this.byLawsService.getBindRoles(action).subscribe(response => {
      if (response?.status === 200 && response?.data) {
        this.roles = response.data;

        if(this.currentUser?.roleId == 9){
          this.roles= this.roles.filter((i:any)=>i?.RoleId== 10 || i?.RoleId== 36 )  
        }
      }

    })
  }

  changeRole(event: any) {

    let val = event.target.value

    if (val == 11) {
      this.remarkList?.IsBlockInspectorRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sBlockInspectorRemark,
        'remarkDate': this.remarkList?.dBlockInspectorRemarkDate,
        'FilePath': this.remarkList?.sBlockInspectorDocument

      })

      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sBlockInspectorRemark)
    } else if (val == 19) {
      this.remarkList?.sDistrictAuditOfficerRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sDistrictAuditOfficerRemark,
        'remarkDate': this.remarkList?.dDistrictAuditOfficerRemarkDate,
        'FilePath': this.remarkList?.sDistrictAuditOfficerDocument

      })
    } else if (val == 13) {
      this.remarkList?.IsAssistantRegistrarRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sAssistantRegistrarRemark,
        'remarkDate': this.remarkList?.dAssistantRegistrarRemarkDate,
        'FilePath': this.remarkList?.sAssistantRegistrarDocument

      })
      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sAssistantRegistrarRemark)
    } else if (val == 36) {
      this.remarkList?.IsDealingHeadRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sDealingHeadRemark,
        'remarkDate': this.remarkList?.dDealingHeadRemarkDate,
        'FilePath': this.remarkList?.sDealingHeadDocument

      })

      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sBlockInspectorRemark)
    } else if (val == 37) {
      this.remarkList?.IsBranchOfficerRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sBranchOfficerRemark,
        'remarkDate': this.remarkList?.dBranchOfficerRemarkDate,
        'FilePath': this.remarkList?.sBranchOfficerDocument

      })
    } else {
      this.remarkList?.IsRegistrarRemark && (this.selectedRemarkDetails = {
        'remark': this.remarkList?.sRegistrarRemark,
        'remarkDate': this.remarkList?.dRegistrarRemarkDate,
        'FilePath': this.remarkList?.sRegistrarDocument

      })
      // this.updateStatusForm.controls['remark'].setValue(this.remarkList.sAssistantRegistrarRemark)
    }

    // this.selectedRemarkDetails && this.openAmendmentsModal()

  }


  getDisclaimer() {
    this.byLawsService.getDisclaimer().subscribe(res => {
      if (res?.data && res?.data.length > 0) {
        this.disclamerOptions = res.data;
        this.disclamerOptionsBackup = JSON.parse(JSON.stringify(res?.data));
      }

    },
      (error: any) => {
        //this.toastService.showError(error.message);
      }
    );
  }
  showDiclamer(row: any) {
    this.showDisclamer = true
    this.disclamerOptions = (row.isLiablity == 1) ? JSON.parse(JSON.stringify(this.disclamerOptionsBackup)) : JSON.parse(JSON.stringify(this.disclamerOptionsBackup.slice(2, 4)))
    this.openAmendmentsModal()
  }
  openAmendmentsModal() {
    const modalElement = document.getElementById('remarkDetails');
    if (modalElement) {
      const modal = new Modal(modalElement);
      modal.show();
    }
  }


  closeRemarkModel() {
    this.selectedRemarkDetails = ''
  }
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();
    // filter our data and update the rows
    this.AmendmentsList = this.temp.filter(function (d: any) {
      return d.dCreateDate.toString().toLowerCase().indexOf(val) !== -1 ||
        d.sSocietyName.toString().toLowerCase().indexOf(val) !== -1 ||
        d.sName.toString().toLowerCase().indexOf(val) !== -1 ||
        d.SBlockName?.toString().toLowerCase().indexOf(val) !== -1 ||
        d.sAuditStatus?.toString().toLowerCase().indexOf(val) !== -1 || !val;
    });
  }


  getUserRemarks(iByLawsId: any, action: any) {

    this.byLawsService.getRemarks(iByLawsId, action).subscribe(res => {
      if (res?.data && res?.data.length > 0) {
        this.remarkList = res?.data[0]

      } else {
        this.remarkList = []

      }


    },
      (error: any) => {
        this.toastService.showError(error.message);
      }
    );
  }



  getBindByLawsOrderDetail(data: any) {
    if (this.currentUser.roleId == 9) {
      data.iSocietyDetailsId = this.societyDetails?.iSocietyDetailsId
    }

    this.byLawsService.getBindByLawsOrderDetail(data).subscribe((res: any) => {
      if (res?.status == 200 && res?.data && res?.data.length > 0) {
        this.orderData = res?.data;
        
      } else {
        this.orderData = [];
      }

    }, (res) => {

      if (res.status != 200) {

        this.toastService.showError('Something went wrong')
      }
    })
  }
  print() {
    let content: any = document.getElementById('ordercontent')
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('portrait', 'pt', 'a4');
      pdf.addImage(imgData, 'PNG', 20, 20, 550, 750);
      pdf.save('Bylaws_Order.pdf');
    });

  }


  viewMore(event: any) {
    this.ExpendeText = event
    this.openModal('readMoreModal')
  }
  hideViewMore() {
    this.ExpendeText = ''
    this.hideModal('readMoreModal')
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  formatBylaws(text: string | null | undefined): string {
  if (!text) return 'NA';

  return text
    .split('|')
    .map(x => x.trim())
    .filter(x => x)
    .join(', ');
}

}
